export default __webpack_public_path__ + "static/media/404-page.a018f968.png";